import React from 'react';
export type CurvePlacement = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
export type CurveVariant = 'moon' | 'wave';
interface DecorCurveProps {
  variant?: CurveVariant;
  placement?: CurvePlacement;
  /** Taille du motif, en classes Tailwind. */
  className?: string;
}

/**
 * Le motif de courbe qui revient sur tous les blocs bleus du site de Beaconsfield.
 *
 * La couleur vient de `currentColor` : c'est une classe `text-*` posée sur le parent qui
 * la pilote, ce qui permet le même tracé en ton clair sur marine et en marine sur royal,
 * sans dupliquer le composant.
 *
 * `preserveAspectRatio="none"` laisse volontairement le tracé s'étirer avec le bloc —
 * c'est ce qui donne l'arc allongé des bandeaux pleine largeur.
 */
const paths: Record<CurveVariant, string> = {
  // Grand disque débordant : les cartes et panneaux carrés.
  moon: 'M50,-18 A68,68 0 1,1 -18,50 A68,68 0 0,1 50,-18 Z',
  // Balayage ancré dans l'angle : les bandeaux pleine largeur.
  wave: 'M0,0 H58 C58,44 33,78 0,94 Z'
};
const placements: Record<CurvePlacement, string> = {
  'top-left': 'left-0 top-0',
  'top-right': 'right-0 top-0 -scale-x-100',
  'bottom-left': 'bottom-0 left-0 -scale-y-100',
  'bottom-right': 'bottom-0 right-0 -scale-100'
};
export function DecorCurve({
  variant = 'moon',
  placement = 'top-left',
  className = 'h-full w-1/2'
}: DecorCurveProps) {
  return <svg viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" focusable="false" className={`pointer-events-none absolute select-none ${placements[placement]} ${className}`} data-id="element-2859" data-mp="32k93fu1vhs85">
      <path d={paths[variant]} fill="currentColor" data-id="element-2860" data-mp="3cbdisuvgnf3i" />
    </svg>;
}